import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {/*Hi Everyone, I am <span className="purple">Soumyajit Behera </span>
            from <span className="purple"> Bhubaneswar, India.</span>*/}
            I am a budding Data Analyst who is meticulous, thorough and passionate about helping businesses succeed. I possess strong techincal skills rooted in sizeable training as an engineer.
            <br />
            <br />
            Apart from software development and data analysis, here's some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> I love playing basketball and have represented my state in the national championships twice. 
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> I am an avid soccer fan. Talk to me about Manchester United!
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> I'm always tinkering with my fantasy teams. If you want to collaborate on an AI project that can get us into the top 10, hit me up!
            </li>
          </ul>

          {/*<p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Without data, you're just another person with an opinion."{" "}
          </p>*/}
          {/*<footer className="blockquote-footer">Soumyajit</footer>*/}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
